import { NgModule } from '@angular/core';
import { PreloadAllModules, Routes, RouterModule } from '@angular/router';

import { AuthGuardService } from './users/auth-guard.service';
import { SuperAdminGuard } from './admin-auth.guard';

const routes: Routes = [{
  path: 'charges',
  loadChildren: () => import('./charges/charges.module').then(m => m.ChargesModule),
  canActivate: [AuthGuardService]
}, {
  path: 'odometers',
  loadChildren: () => import('./odometers/odometers.module').then(m => m.OdometersModule),
  canActivate: [AuthGuardService]
}, {
  path: 'pricings',
  loadChildren: () => import('./pricings/pricings.module').then(m => m.PricingsModule),
  canActivate: [SuperAdminGuard]
}, {
  path: 'incentives',
  loadChildren: () => import('./incentives/incentives.module').then(m => m.IncentivesModule),
  canActivate: [AuthGuardService]
}, {
  path: 'programs',
  loadChildren: () => import('./programs/programs.module').then(m => m.ProgramsModule),
  canActivate: [SuperAdminGuard]
}, {
  path: 'transactions',
  loadChildren: () => import('./transactions/transactions.module').then(m => m.TransactionsModule),
  canActivate: [AuthGuardService]
}, {
  path: 'users',
  loadChildren: () => import('./users/users.module').then(m => m.UsersModule)
}, {
  path: 'vehicles',
  loadChildren: () => import('./vehicles/vehicles.module').then(m => m.VehiclesModule),
  canActivate: [AuthGuardService]
}, {
  path: 'search',
  loadChildren: () => import('./search/search.module').then(m => m.SearchModule),
  canActivate: [AuthGuardService]
}, {
  path: 'vehicle-trips',
  loadChildren: () => import('./vehicle-trips/vehicle-trips.module').then(m => m.VehicleTripsModule),
  canActivate: [AuthGuardService]
}, {
  path: 'subscriptions',
  loadChildren: () => import('./subscriptions/subscriptions.module').then(m => m.SubscriptionsModule),
  canActivate: [SuperAdminGuard]
}, {
  path: 'network-configs',
  loadChildren: () => import('./network-configs/network-configs.module').then(m => m.NetworkConfigsModule),
  canActivate: [SuperAdminGuard]
}, {
  path: 'devices',
  loadChildren: () => import('./devices/devices.module').then(m => m.DevicesModule),
  canActivate: [AuthGuardService]
},{
  path: 'notification',
  loadChildren: () => import('./notification/notification.module').then(m => m.NotificationModule),
  canActivate: [SuperAdminGuard]
},
//   {
//   path: 'requests',
//   loadChildren: () => import('./requests/requests.module').then(m => m.RequestsModule),
//   canActivate: [AuthGuardService]
// },
  {
  path: 'networks',
  loadChildren: () => import('./networks/networks.module').then(m => m.NetworksModule),
  canActivate: [AuthGuardService]
}, {
  path: '**',
  redirectTo: 'search'
}];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
    relativeLinkResolution: 'legacy'
})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
